export class RoleMaster {
  roleId: any;
  roleName: string;
  roleStatus: string;
}

export class CourseMaster {
  courseId: any;
  courseName: string;
  courseStatus: string;
  courseFee: any;
}

export class FollowupMaster {
  followupId: any;
  followupName: string;
  followupStatus: string;
}

export class PaymentMaster {
  paymentId: any;
  paymentName: string;
  paymentStatus: string;
}

export class SourceLeadMaster {
  sourceLeadId: any;
  sourceLeadName: string;
  sourceLeadStatus: string;
}

export class ExpenseMaster {
  expenseId: any;
  expenseName: string;
  expenseStatus: string;
}

export class ClassMaster {
  classId: any;
  classWebsite: string;
  classMail: string;
  className: string;
}
export class BranchMaster {
  branchId: any;
  branchName: string;
  branchStatus: string;
  branchAddress: string;
  branchEmail: string;
  branchMobile: string;
}
export class BatchMaster {
  batchId: any;
  batchName: string;
  batchFromDate: string;
  batchToDate: string;
  batchStatus: string;
  branchId: string;
  courseId: string;
  courseMaster: any;
}

export class StaffMaster {
  staffId: any;
  staffFullName: string;
  staffAddress: string;
  staffEmail: string;
  staffMobileNumber: string;
  staffDateOfBirth: any;
  staffGender: string;
  staffStatus: string;
  roleId: string;
  branchList: Array<any> = [];
  branchNames: any;
  staffPassword: any;
}

export class PrivilegeMaster {
  privilegeId: any;
  staffMaster: any;
  privilegeData: string;
  staffId: any;
}
export class LoginMaster {
  staffMobileNumber: string;
  staffPassword: string;
}

export class BranchLoginMaster {
  branchList: string;
}

export class LeadMaster {
  leadId: any;
  fullName: string;
  contactNumber: string;
  whatsAppNumber: string;
  enquiryDate: any;
  followupDateTime: any;
  gender: string;
  email: string;
  followupRemark: string;
  staffMaster: StaffMaster;
  staffId: any;
  sourceLeadMaster: SourceLeadMaster;
  sourceLeadId: any;
  followupMaster: FollowupMaster;
  followupId: any;
  courseMasterList: Array<CourseMaster> = [];
  batchMasterList: Array<BatchMaster> = [];
  branchMaster: BranchMaster;
  branchId: any;
  courseNames: any;
  batchNames: any;
}

export class LeadWiseFollowupMaster {
  leadWiseFollowupId: any;
  followupDateTime: any;
  followupMaster: any;
  followupId: any;
  followupRemark: string;
  leadMaster: any;
  leadId: any;
  batchMasterList: Array<BatchMaster> = [];
  staffMaster: StaffMaster;
  staffId: any;
  leadWiseFollowupInsertDate: any;
  batchNames: string;
}

export class LeadFilterReqDto {
  staffMasterList: Array<StaffMaster> = [];
  courseMasterList: Array<CourseMaster> = [];
  batchMasterList: Array<BatchMaster> = [];
  followupMasterList: Array<FollowupMaster> = [];
  sourceLeadMasterList: Array<SourceLeadMaster> = [];
  leadFromDate: any;
  leadToDate: any;
  followUpLeadFromDate: any;
  followUpLeadToDate: any;
  searchString: string = "";
  pageIndex: Number;
  pageSize: Number;
  branchId: any;
  followupDateWise: boolean = false;
  forExcel: boolean = false;
  message: any;
  galleryMasterList: Array<GalleryMaster> = [];
  messageFrom: any;
}
export class AdmissionFilterReqDto {
  staffMasterList: Array<StaffMaster> = [];
  courseMasterList: Array<CourseMaster> = [];
  batchMasterList: Array<BatchMaster> = [];
  followupMasterList: Array<FollowupMaster> = [];
  sourceLeadMasterList: Array<SourceLeadMaster> = [];
  admissionFromDate: any;
  admissionToDate: any;
  searchString: string = "";
  pageIndex: Number;
  pageSize: Number;
  branchId: any;
  feesStatusList: Array<string> = [];
  forExcel: boolean = false;
  message: any;
  galleryMasterList: Array<GalleryMaster> = [];
  messageFrom: any;
  batchFromDate: any;
  batchToDate: any;
}
export class LeadTransfer {
  leadTransferId: any;
  transferDate: any;
  fromBranchMaster: BranchMaster;
  fromBranchId: any;
  toBranchMaster: BranchMaster;
  toBranchId: any;
  mainStaffMaster: StaffMaster;
  fromStaffMaster: StaffMaster;
  fromStaffId: any;
  toStaffMaster: StaffMaster;
  toStaffId: any;
  leadMaster: LeadMaster;
  leadId: any;
}

export class AdmissionMaster {
  admissionId: any;
  leadMaster: LeadMaster;
  leadId: any;
  staffMaster: StaffMaster;
  staffId: any;
  admissionDate: any;
  feesAmount: any = 0;
  extraCharges: any = 0;
  discountAmount: any = 0;
  discountPercentage: any = 0;
  totalAmount: any = 0;
  gstStatus: string;
  gstPercentage: any = 0;
  gstType: string;
  gstAmount: any = 0;
  finalAmount: any = 0;
  paidAmount: any = 0;
  remainingAmount: any = 0;
  admissionStatus: string;
  installmentMasterNextDate: any;
  paymentId: any;
  batchMasterList: Array<BatchMaster>;
  courseMasterList: Array<CourseMaster> = [];
  readmissionPaidAmount: any = 0;
}

export class InstallmentMaster {
  installmentMasterId: any;
  installmentMasterNextDate: any;
  installmentMasterPaidAmount: any = 0;
  installmentMasterRemainingAmount: any = 0;
  installmentMasterDate: any;
  staffMaster: StaffMaster;
  staffId: any;
  admissionMaster: AdmissionMaster;
  admissionId: any;
  paymentMaster: PaymentMaster;
  paymentId: any;
  discountAmount: any;
}

export class GenerateExpenseMaster {
  generateExpenseId: any;
  generateExpenseName: string;
  generateExpenseAmount: any;
  expenseMaster: ExpenseMaster;
  generateExpenseDate: any;
  expenseId: any;
  expenseCategory: ExpenseCategoryMaster;
  expenseCategoryId: any;
  staffMaster: any;
  staffId: any;
  branchMaster: BranchMaster;
  branchId: any;
  paymentMaster: PaymentMaster;
  paymentId: any;
}
export class UpdateBranchBatchReqDto {
  admissionId: any;
  leadId: any;
  fromBranchId: any;
  toBranchId: any;
  fromStaffId: any;
  toStaffId: any;
  batchMasterList: Array<BatchMaster> = [];
}
export class RefundReqDto {
  cancelPercentage: any;
  cancelAmount: any;
  admissionId: any;
  tempPaidFees: any;
  fullName: any;
  refundPaymentId: any;
}
export class PerformanceReportReqDto {
  staffMasterList: Array<StaffMaster> = [];
  courseMasterList: Array<CourseMaster> = [];
  batchMasterList: Array<BatchMaster> = [];
  followupMasterList: Array<FollowupMaster> = [];
  sourceLeadMasterList: Array<SourceLeadMaster> = [];
  leadFromDate: any;
  leadToDate: any;
  followUpLeadFromDate: any;
  followUpLeadToDate: any;
  searchString: string = "";
  pageIndex: Number;
  pageSize: Number;
  branchMasterList: Array<BranchMaster> = [];
  followupDateWise: boolean = false;
  admissionFromDate: any;
  admissionToDate: any;
  feesStatusList: Array<string> = [];
  forExcel: boolean = false;
}
export class EmsDashboardReqDto {
  staffMasterList: Array<StaffMaster> = [];
  courseMasterList: Array<CourseMaster> = [];
  batchMasterList: Array<BatchMaster> = [];
  followupMasterList: Array<FollowupMaster> = [];
  sourceLeadMasterList: Array<SourceLeadMaster> = [];
  leadFromDate: any;
  leadToDate: any;
  followUpLeadFromDate: any;
  followUpLeadToDate: any;
  searchString: string = "";
  pageIndex: Number;
  pageSize: Number;
  branchId: any;
  followupDateWise: boolean = false;
  admissionFromDate: any;
  admissionToDate: any;
  feesStatusList: Array<string> = [];
}

export class InstallmentFilterReqDto {
  staffMasterList: Array<StaffMaster> = [];
  courseMasterList: Array<CourseMaster> = [];
  batchMasterList: Array<BatchMaster> = [];
  paymentMasterList: Array<PaymentMaster> = [];
  installmentMasterFromDate: any;
  installmentMasterToDate: any;
  searchString: string = "";
  pageIndex: Number;
  pageSize: Number;
  branchId: any;
  feesStatusList: Array<string> = [];
  forExcel: boolean = false;
  batchFromDate: any;
  batchToDate: any;
}

export class ExpenseCategoryMaster {
  expenseCategoryId: any;
  expenseCategoryName: string;
  expenseCategoryStatus: string;
}

export class ExpenseMasterReportReqDto {
  expenseMasterList: Array<ExpenseMaster> = [];
  expenseCategoryMasterList: Array<ExpenseCategoryMaster> = [];
  staffMasterList: Array<StaffMaster> = [];
  paymentMasterList: Array<PaymentMaster> = [];
  generateExpenseFromDate: any;
  generateExpenseToDate: any;
  searchString: any = "";
  pageIndex: any;
  pageSize: any;
  branchId: any;
  forExcel: boolean = false;
}

export class FollowUpCallReportReqDto {
  staffMasterList: Array<StaffMaster> = [];
  followupMasterList: Array<FollowupMaster> = [];
  followupFromDate: any;
  followupToDate: any;
  searchString: string = "";
  pageIndex: any;
  pageSize: any;
  branchId: any;
  forExcel: boolean = true;
  sourceLeadMasterList: Array<SourceLeadMaster> = [];
}

export class FollowUpCallReportResDto {
  batchNames: any;
  leadId: any;
  courseNames: any;
  staffFullName: any;
  followupRemark: any;
  followupName: any;
  followupDateTime: any;
  flag: boolean;
  fullName: any;
  contactNumber: any;
  whatsAppNumber: any;
}

export class LeadTransferredReqDto {
  fromStaffMasterList: Array<StaffMaster> = [];
  toStaffMasterList: Array<StaffMaster> = [];
  fromBranchMasterList: Array<BranchMaster> = [];
  toBranchMasterList: Array<BranchMaster> = [];
  fromDate: any;
  toDate: any;
  isAdmission: any;
  pageIndex: any;
  pageSize: any;
  branchId: any;
  forExcel: boolean = false;
  searchString: string = "";
}

export class GalleryMaster {
  galleryMasterId: any;
  galleryMasterName: string;
  galleryMasterUrl: string;
}
